import React, { useEffect, useState } from 'react';
import { Form, Input, Button, Space, Upload, Col, Row, Select } from 'antd';
import AddDrawer from '../../component/AddDrawer';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import '../../style/page.css'
import { useDispatch, useSelector } from 'react-redux';
import { addSubscription, editSubscription, getSubscription } from '../../feature/subscription/subscriptionSlice';


function EditSubscription({ editData }) {
    const { _id,
        durationInMonths,
        planName,
        description,
        price, numberOfChildrens, numberOfTeachers, numberOfAdmins } = editData
    const { actionLoader } = useSelector((state) => state.subscriptions);
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const dispatch = useDispatch()

    console.log("edit props", editData)

    useEffect(() => {
        form.setFieldsValue({
            durationInMonths,
            planName,
            description,
            price,
            numberOfChildrens, numberOfTeachers, numberOfAdmins
        })
    }, [editData])
    const onFinish = async (values) => {
        const resultAction = await dispatch(editSubscription({ ...values, subscriptionId: _id }));
        if (editSubscription.fulfilled.match(resultAction)) {
            await dispatch(getSubscription({}));
            form.resetFields();
            setOpen(false);
        } else {
            console.error("edit subscription");
        }
    };

    const onFinishFailed = (errorInfo) => {
        console.log('Validation Failed:', errorInfo);
    };

    const handleCancel = () => {
        form.resetFields();
    };


    const AddForm = (
        <Form
            layout="vertical"
            form={form}
            name="add-service-form"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}

        >
            <Form.Item
                name="planName"
                label="Plan Name"
                rules={[{ required: true, message: 'Please enter plan name' }]}
            >
                <Input placeholder="Enter Plan Name" size='large' />
            </Form.Item>
            <Form.Item
                name="durationInMonths"
                label="Duration"
                rules={[{ required: true, message: 'Please enter duration in months ' }]}
            >
                <Input placeholder='Duration' suffix="Months" />
            </Form.Item>
            <Form.Item
                name="price"
                label="Price"
                rules={[{ required: true, message: 'Please enter price' }, {
                    pattern: /^[0-9]+$/,
                    message: "Only numbers are allowed!",
                },]}
            >
                <Input placeholder="Enter Price" size='large' />
            </Form.Item>
            <Form.Item
                name="numberOfAdmins"
                label="Admin"
                rules={[{ required: true, message: 'Please enter number Of admins' }, {
                    pattern: /^[0-9]+$/,
                    message: "Only numbers are allowed!",
                },]}
            >
                <Input placeholder="Enter No. Of Admin" size='large' />
            </Form.Item>
            <Form.Item
                name="numberOfChildrens"
                label="Children"
                rules={[{ required: true, message: 'Please enter number Of childrens' }, {
                    pattern: /^[0-9]+$/,
                    message: "Only numbers are allowed!",
                },]}
            >
                <Input placeholder="Enter No. Of Childrens" size='large' />
            </Form.Item>
            <Form.Item
                name="numberOfTeachers"
                label="Teacher"
                rules={[{ required: true, message: 'Please enter number Of teachers' }, {
                    pattern: /^[0-9]+$/,
                    message: "Only numbers are allowed!",
                },]}
            >
                <Input placeholder="Enter No. Of Teachers" size='large' />
            </Form.Item>
            {/* Description */}
            <Form.Item
                name="description"
                label="Description"
                rules={[{ required: true, message: 'Please enter description' }]}
            >
                <Input.TextArea placeholder="Enter description..." />
            </Form.Item>
            <Form.Item  >

                <div className='submit_btn'>
                    <Space>
                        <Button type="primary" loading={actionLoader} htmlType="submit">
                            Submit
                        </Button>
                        <Button danger htmlType="button" onClick={handleCancel}>
                            Reset
                        </Button>
                    </Space>
                </div>
            </Form.Item>
        </Form >


    );

    const AddProps = {
        open,
        setOpen,
        title: 'Edit Subscription',
        action: 'Edit',
        content: AddForm,
        btnType: "link"
    };

    return (
        <section>
            <AddDrawer {...AddProps} />
        </section>
    );
}


export default EditSubscription